
export class StoreGroupStoreRec {

  public storeGroupTypeCd:  number;
  public storeGroupCd:      number;
  public storeCd:           string;
  public storeName:         string;

}